import React, { useState, useEffect } from 'react';
import api from '../api/client';

const inp = { width: '100%', padding: '9px 12px', border: '1px solid #e8e8e6', borderRadius: 8, fontSize: 14, marginBottom: 10, boxSizing: 'border-box', outline: 'none', display: 'block' };
const btnPrimary = { padding: '8px 16px', background: '#534AB7', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 500, fontSize: 13, cursor: 'pointer' };
const btnGhost = { padding: '7px 12px', background: 'none', border: '1px solid #e8e8e6', borderRadius: 8, fontSize: 13, cursor: 'pointer', color: '#555' };
const btnDanger = { padding: '7px 12px', background: 'none', border: '1px solid #c0392b', borderRadius: 8, fontSize: 13, cursor: 'pointer', color: '#c0392b' };

export default function Accounts() {
  const [accounts, setAccounts] = useState([]);
  const [agents, setAgents] = useState([]);
  const [proxies, setProxies] = useState([]);
  const [showUpload, setShowUpload] = useState(false);
  const [uploadMode, setUploadMode] = useState('session'); // 'session' | 'tdata'
  const [tdataFile, setTdataFile] = useState(null);
  const [showBatchUpload, setShowBatchUpload] = useState(false);
  const [batchFile, setBatchFile] = useState(null);
  const [batchProxyIds, setBatchProxyIds] = useState([]);
  const [batchAgentId, setBatchAgentId] = useState('');
  const [batchResults, setBatchResults] = useState(null);
  const [batchLoading, setBatchLoading] = useState(false);
  const [showPhoneAuth, setShowPhoneAuth] = useState(false);
  const [phoneStep, setPhoneStep] = useState(1);
  const [phoneForm, setPhoneForm] = useState({ phone: '', api_id: '', api_hash: '', code: '', password: '', name: '', agent_id: '', proxy_id: '' });
  const [phoneKey, setPhoneKey] = useState('');
  const [showProfile, setShowProfile] = useState(null);
  const [showSend, setShowSend] = useState(null);
  const [uploadForm, setUploadForm] = useState({ agent_id: '', proxy_id: '' });
  const [sessionFile, setSessionFile] = useState(null);
  const [jsonFile, setJsonFile] = useState(null);
  const [profileForm, setProfileForm] = useState({ first_name: '', last_name: '', bio: '' });
  const [sendForm, setSendForm] = useState({ target: '', message: 'Привет, {имя}! ' });
  const [showSettings, setShowSettings] = useState(null);
  const [settingsForm, setSettingsForm] = useState({ username: '', daily_limit: 40 });
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');

  const load = async () => {
    const [a, ag, px] = await Promise.all([api.get('/accounts'), api.get('/agents'), api.get('/proxies')]);
    setAccounts(a.data); setAgents(ag.data); setProxies(px.data);
  };
  useEffect(() => { load(); }, []);

  const uploadBatch = async () => {
    if (!batchFile) { return; }
    setBatchLoading(true);
    const files = Array.isArray(batchFile) ? batchFile : [batchFile];
    for (const file of files) {
      setBatchResults(null);
      try {
        const form = new FormData();
        form.append('archive', file);
        if (batchAgentId) form.append('agent_id', batchAgentId);
        if (batchProxyIds.length) form.append('proxy_ids', JSON.stringify(batchProxyIds));
        const { data } = await api.post('/accounts/telegram/upload-batch', form, { headers: { 'Content-Type': 'multipart/form-data' } });
        setBatchResults(data);
        await load();
      } catch (e) {
        setBatchResults({ ok: false, error: e.response?.data?.detail || 'Ошибка загрузки' });
      }
    }
    setBatchLoading(false);
  };

  const toggleBatchProxy = (id) => {
    setBatchProxyIds(ids => ids.includes(id) ? ids.filter(x => x !== id) : [...ids, id]);
  };

  const closeBatchUpload = () => {
    setShowBatchUpload(false); setBatchFile(null); setBatchResults(null); setBatchProxyIds([]); setBatchAgentId('');
  };

  const upload = async () => {
    if (uploadMode === 'tdata') {
      if (!tdataFile) { setMsg('Выберите ZIP с папкой tdata'); return; }
      setLoading(true); setMsg('');
      try {
        const form = new FormData();
        form.append('archive', tdataFile);
        if (uploadForm.agent_id) form.append('agent_id', uploadForm.agent_id);
        if (uploadForm.proxy_id) form.append('proxy_id', uploadForm.proxy_id);
        await api.post('/accounts/telegram/upload-tdata', form, { headers: { 'Content-Type': 'multipart/form-data' } });
        setShowUpload(false); setTdataFile(null);
        setUploadForm({ agent_id: '', proxy_id: '' });
        await load();
      } catch (e) { setMsg(e.response?.data?.detail || 'Ошибка загрузки'); }
      setLoading(false);
      return;
    }
    if (!sessionFile || !jsonFile) { setMsg('Выберите оба файла'); return; }
    setLoading(true); setMsg('');
    try {
      const form = new FormData();
      form.append('session_file', sessionFile);
      form.append('json_file', jsonFile);
      if (uploadForm.agent_id) form.append('agent_id', uploadForm.agent_id);
      if (uploadForm.proxy_id) form.append('proxy_id', uploadForm.proxy_id);
      await api.post('/accounts/telegram/upload', form, { headers: { 'Content-Type': 'multipart/form-data' } });
      setShowUpload(false); setSessionFile(null); setJsonFile(null);
      setUploadForm({ agent_id: '', proxy_id: '' });
      await load();
    } catch (e) { setMsg(e.response?.data?.detail || 'Ошибка загрузки'); }
    setLoading(false);
  };

  const checkSpam = async (id) => {
    setLoading(true);
    try {
      const { data } = await api.post(`/accounts/${id}/check-spam`);
      alert(data.status + (data.details ? '\n\n' + data.details : ''));
      await load();
    } catch (e) { alert(e.response?.data?.detail || 'Ошибка'); }
    setLoading(false);
  };

  const updateProfile = async () => {
    setLoading(true);
    try {
      await api.post(`/accounts/${showProfile.id}/update-profile`, profileForm);
      setShowProfile(null); await load();
    } catch (e) { alert(e.response?.data?.detail || 'Ошибка'); }
    setLoading(false);
  };

  const sendFirst = async () => {
    if (!sendForm.target) { alert('Введите username или номер'); return; }
    setLoading(true);
    try {
      const { data } = await api.post(`/accounts/${showSend.id}/send-first`, sendForm);
      alert(`Отправлено для ${data.sent_to}`);
      setShowSend(null);
    } catch (e) { alert(e.response?.data?.detail || 'Ошибка'); }
    setLoading(false);
  };

  const requestPhoneCode = async () => {
    if (!phoneForm.phone) { setMsg('Введите номер телефона'); return; }
    setLoading(true); setMsg('');
    try {
      const payload = { phone: phoneForm.phone };
      if (phoneForm.api_id) payload.api_id = parseInt(phoneForm.api_id);
      if (phoneForm.api_hash) payload.api_hash = phoneForm.api_hash;
      const { data } = await api.post('/accounts/telegram/auth/request-code', payload);
      setPhoneKey(data.key);
      setPhoneStep(2);
    } catch (e) { setMsg(e.response?.data?.detail || 'Ошибка'); }
    setLoading(false);
  };

  const confirmPhoneCode = async () => {
    if (!phoneForm.code) { setMsg('Введите код из Telegram'); return; }
    setLoading(true); setMsg('');
    try {
      await api.post('/accounts/telegram/auth/confirm-code', {
        key: phoneKey,
        code: phoneForm.code,
        password: phoneForm.password || undefined,
        name: phoneForm.name || undefined,
        agent_id: phoneForm.agent_id ? parseInt(phoneForm.agent_id) : undefined,
        proxy_id: phoneForm.proxy_id ? parseInt(phoneForm.proxy_id) : undefined,
      });
      setShowPhoneAuth(false);
      setPhoneStep(1);
      setPhoneForm({ phone: '', api_id: '', api_hash: '', code: '', password: '', name: '', agent_id: '', proxy_id: '' });
      await load();
    } catch (e) { setMsg(e.response?.data?.detail || 'Ошибка'); }
    setLoading(false);
  };

  const closePhoneAuth = async () => {
    if (phoneKey) {
      try { await api.post(`/accounts/telegram/auth/cancel?key=${phoneKey}`); } catch {}
    }
    setShowPhoneAuth(false); setPhoneStep(1); setPhoneKey('');
    setPhoneForm({ phone: '', api_id: '', api_hash: '', code: '', password: '', name: '', agent_id: '', proxy_id: '' });
  };

  const toggle = async (id) => { await api.post(`/accounts/${id}/toggle`); await load(); };

  const toggleWarmup = async (acc) => {
    try {
      if (acc.warmup_enabled) {
        await api.post(`/warmup/${acc.id}/disable`);
      } else {
        await api.post(`/warmup/${acc.id}/enable`);
      }
      await load();
    } catch (e) { alert(e.response?.data?.detail || 'Ошибка'); }
  };

  const assignAgent = async (id, agent_id) => {
    await api.put(`/accounts/${id}/agent`, { agent_id: agent_id ? parseInt(agent_id) : null });
    await load();
  };
  const assignProxy = async (id, proxy_id) => {
    await api.put(`/accounts/${id}/proxy`, { proxy_id: proxy_id ? parseInt(proxy_id) : null });
    await load();
  };
  const del = async (id) => {
    if (!window.confirm('Удалить аккаунт?')) return;
    await api.delete(`/accounts/${id}`); await load();
  };

  const saveSettings = async () => {
    setLoading(true);
    try {
      await api.put(`/accounts/${showSettings.id}/settings`, settingsForm);
      setShowSettings(null); await load();
    } catch (e) { alert(e.response?.data?.detail || 'Ошибка'); }
    setLoading(false);
  };

  return (
    <div style={{ padding: 32 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={{ fontSize: 20, fontWeight: 600, margin: 0 }}>Аккаунты Telegram</h1>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={() => { setShowPhoneAuth(true); setMsg(''); }} style={btnGhost}>📱 Войти по номеру</button>
          <button onClick={() => { setShowBatchUpload(true); }} style={btnGhost}>📦 Массовая загрузка</button>
          <button onClick={() => { setShowUpload(true); setMsg(''); }} style={btnPrimary}>+ Загрузить аккаунт</button>
        </div>
      </div>

      {accounts.length === 0 && (
        <div style={{ textAlign: 'center', padding: 60, color: '#aaa', fontSize: 14 }}>
          Нет аккаунтов. Загрузите первый в формате <b>session + json</b>.
        </div>
      )}

      <div style={{ display: 'grid', gap: 12 }}>
        {accounts.map(acc => (
          <div key={acc.id} style={{ background: '#fff', border: `1px solid ${acc.spam_block ? '#f5c6cb' : '#e8e8e6'}`, borderRadius: 10, padding: '14px 16px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
              <div style={{ fontSize: 22 }}>✈️</div>
              <div style={{ flex: 1, minWidth: 160 }}>
                <div style={{ fontWeight: 500, fontSize: 14 }}>{acc.first_name || acc.name}</div>
                <div style={{ fontSize: 12, color: '#888' }}>
                  {acc.phone && <span>{acc.phone} · </span>}
                  {acc.username && <span>@{acc.username} · </span>}
                  {acc.status === 'active' && <span style={{ color: '#27ae60' }}>● активен</span>}
                  {acc.status === 'flood' && <span style={{ color: '#e67e22' }}>⏳ флуд-лимит</span>}
                  {acc.status === 'reconnecting' && <span style={{ color: '#f39c12' }}>🔄 переподключение...</span>}
                  {acc.status === 'error' && <span style={{ color: '#c0392b' }}>✗ {acc.status_error || 'ошибка'}</span>}
                  {acc.status === 'stopped' && <span style={{ color: '#aaa' }}>○ остановлен</span>}
                  {!acc.status && (acc.running ? <span style={{ color: '#27ae60' }}>● активен</span> : <span style={{ color: '#aaa' }}>○ остановлен</span>)}
                  {acc.spam_block && <span style={{ color: '#c0392b', marginLeft: 6 }}>⚠️ спам-блок</span>}
                </div>
                <div style={{ fontSize: 11, color: '#bbb', marginTop: 2 }}>
                  {acc.created_at && <span>Добавлен: {new Date(acc.created_at).toLocaleDateString('ru-RU')} · </span>}
                  <span>Сегодня: {acc.sent_today || 0}/{acc.daily_limit || 40}</span>
                </div>
              </div>

              <select value={acc.agent_id || ''} onChange={e => assignAgent(acc.id, e.target.value)}
                style={{ padding: '6px 10px', border: '1px solid #e8e8e6', borderRadius: 8, fontSize: 13, outline: 'none', maxWidth: 160 }}>
                <option value="">Без агента</option>
                {agents.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
              </select>

              <select value={acc.proxy_id || ''} onChange={e => assignProxy(acc.id, e.target.value)}
                style={{ padding: '6px 10px', border: '1px solid #e8e8e6', borderRadius: 8, fontSize: 13, outline: 'none', maxWidth: 160 }}>
                <option value="">Без прокси</option>
                {proxies.map(p => <option key={p.id} value={p.id}>{p.flag && p.flag !== '🌐' ? p.flag + ' ' : ''}{p.url.replace(/^socks5:\/\//, '').slice(0, 22)}</option>)}
              </select>

              <button onClick={() => { setShowSend(acc); setSendForm({ target: '', message: 'Привет, {имя}! ' }); }} style={btnPrimary} title="Написать первым">
                ✉️ Написать
              </button>
              <button onClick={() => checkSpam(acc.id)} style={btnGhost} title="Проверить спам-блок">
                🔍 Спам
              </button>
              <button
                onClick={() => toggleWarmup(acc)}
                title={acc.warmup_enabled ? `Warm-up активен: день ${acc.warmup_day || 1}, лимит ${acc.warmup_limit || 5}/сут` : 'Включить прогрев аккаунта'}
                style={{ ...btnGhost,
                  borderColor: acc.warmup_enabled ? '#f39c12' : '#e8e8e6',
                  color: acc.warmup_enabled ? '#f39c12' : '#888',
                  background: acc.warmup_enabled ? '#fef9f0' : 'none',
                }}>
                {acc.warmup_enabled ? `🌡 День ${acc.warmup_day || 1}` : '🌡 Warm-up'}
              </button>
              <button onClick={() => { setShowProfile(acc); setProfileForm({ first_name: acc.first_name || '', last_name: '', bio: '' }); setSettingsForm({ username: acc.username || '', daily_limit: acc.daily_limit || 40 }); }} style={btnGhost}>
                ✏️ Профиль
              </button>

              <button onClick={() => toggle(acc.id)} style={{ ...btnGhost, color: acc.is_active ? '#c0392b' : '#27ae60', borderColor: acc.is_active ? '#c0392b' : '#27ae60' }}>
                {acc.is_active ? 'Выкл' : 'Вкл'}
              </button>
              <button onClick={() => del(acc.id)} style={btnDanger}>🗑</button>
            </div>
          </div>
        ))}
      </div>

      {showUpload && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 28, width: 440 }}>
            <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 4 }}>Загрузить Telegram аккаунт</div>
            <div style={{ fontSize: 13, color: '#888', marginBottom: 16 }}>Выберите формат данных аккаунта</div>

            <div style={{ display: 'flex', gap: 8, marginBottom: 18 }}>
              <button onClick={() => setUploadMode('session')} style={{ flex: 1, padding: '8px 12px', borderRadius: 8, fontSize: 13, fontWeight: 500, cursor: 'pointer', border: uploadMode === 'session' ? '1px solid #534AB7' : '1px solid #e8e8e6', background: uploadMode === 'session' ? '#f0effe' : '#fff', color: uploadMode === 'session' ? '#534AB7' : '#555' }}>
                Session + JSON
              </button>
              <button onClick={() => setUploadMode('tdata')} style={{ flex: 1, padding: '8px 12px', borderRadius: 8, fontSize: 13, fontWeight: 500, cursor: 'pointer', border: uploadMode === 'tdata' ? '1px solid #534AB7' : '1px solid #e8e8e6', background: uploadMode === 'tdata' ? '#f0effe' : '#fff', color: uploadMode === 'tdata' ? '#534AB7' : '#555' }}>
                TDATA (ZIP)
              </button>
            </div>

            {uploadMode === 'session' ? (
              <>
                <div style={{ marginBottom: 12 }}>
                  <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 6 }}>SESSION файл (.session)</div>
                  <input type="file" accept=".session" onChange={e => setSessionFile(e.target.files[0])}
                    style={{ fontSize: 13, width: '100%' }} />
                </div>

                <div style={{ marginBottom: 12 }}>
                  <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 6 }}>JSON файл (.json)</div>
                  <input type="file" accept=".json" onChange={e => setJsonFile(e.target.files[0])}
                    style={{ fontSize: 13, width: '100%' }} />
                </div>
              </>
            ) : (
              <div style={{ marginBottom: 12 }}>
                <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 6 }}>ZIP-архив с папкой tdata</div>
                <div style={{ fontSize: 12, color: '#aaa', marginBottom: 6 }}>
                  Заархивируйте папку tdata из Telegram Desktop и загрузите ZIP
                </div>
                <input type="file" accept=".zip" onChange={e => setTdataFile(e.target.files[0])}
                  style={{ fontSize: 13, width: '100%' }} />
                {tdataFile && <div style={{ fontSize: 12, color: '#27ae60', marginTop: 6 }}>✓ {tdataFile.name}</div>}
              </div>
            )}

            <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 6 }}>Прокси</div>
            <select value={uploadForm.proxy_id} onChange={e => setUploadForm(f => ({ ...f, proxy_id: e.target.value }))} style={inp}>
              <option value="">Без прокси</option>
              {proxies.map(p => <option key={p.id} value={p.id}>{p.flag && p.flag !== '🌐' ? p.flag + ' ' : ''}{p.url} {p.is_working ? '✓' : ''}</option>)}
            </select>

            <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 6 }}>Агент</div>
            <select value={uploadForm.agent_id} onChange={e => setUploadForm(f => ({ ...f, agent_id: e.target.value }))} style={inp}>
              <option value="">Назначить позже</option>
              {agents.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
            </select>

            {msg && <div style={{ color: '#c0392b', fontSize: 13, marginBottom: 12 }}>{msg}</div>}

            {uploadMode === 'session' && sessionFile && jsonFile && (
              <div style={{ fontSize: 12, color: '#27ae60', marginBottom: 10 }}>
                ✓ {sessionFile.name} + {jsonFile.name}
              </div>
            )}

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 4 }}>
              <button onClick={() => setShowUpload(false)} style={btnGhost}>Отмена</button>
              <button onClick={upload} disabled={loading} style={btnPrimary}>
                {loading ? (uploadMode === 'tdata' ? 'Конвертируем TDATA...' : 'Проверяем сессию...') : 'Загрузить'}
              </button>
            </div>
          </div>
        </div>
      )}

      {showProfile && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 28, width: 400 }}>
            <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 16 }}>Редактировать профиль</div>
            <input placeholder="Имя" value={profileForm.first_name} onChange={e => setProfileForm(f => ({ ...f, first_name: e.target.value }))} style={inp} />
            <input placeholder="Фамилия" value={profileForm.last_name} onChange={e => setProfileForm(f => ({ ...f, last_name: e.target.value }))} style={inp} />
            <textarea placeholder="Bio" value={profileForm.bio} onChange={e => setProfileForm(f => ({ ...f, bio: e.target.value }))}
              rows={3} style={{ ...inp, resize: 'vertical' }} />
            <div style={{ borderTop: '1px solid #e8e8e6', margin: '12px 0' }} />
            <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 6 }}>Username</div>
            <input placeholder="username (без @)" value={settingsForm.username}
              onChange={e => setSettingsForm(f => ({ ...f, username: e.target.value }))} style={inp} />
            <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 6 }}>Дневной лимит отправки</div>
            <input type="number" min="1" max="500" value={settingsForm.daily_limit}
              onChange={e => setSettingsForm(f => ({ ...f, daily_limit: e.target.value }))} style={inp} />
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={() => setShowProfile(null)} style={btnGhost}>Отмена</button>
              <button onClick={async () => { await updateProfile(); if (showProfile) { await api.put('/accounts/' + showProfile.id + '/settings', settingsForm); } }} disabled={loading} style={btnPrimary}>{loading ? '...' : 'Сохранить'}</button>
            </div>
          </div>
        </div>
      )}

      {showSend && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 28, width: 440 }}>
            <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 4 }}>Написать первым</div>
            <div style={{ fontSize: 13, color: '#888', marginBottom: 16 }}>
              Аккаунт: <b>{showSend.first_name || showSend.name}</b>
            </div>
            <input placeholder="@username или +79001234567" value={sendForm.target}
              onChange={e => setSendForm(f => ({ ...f, target: e.target.value }))} style={inp} />
            <div style={{ fontSize: 12, color: '#aaa', marginBottom: 6 }}>
              Используй <b>{'{имя}'}</b> — подставится реальное имя из профиля Telegram
            </div>
            <textarea value={sendForm.message} onChange={e => setSendForm(f => ({ ...f, message: e.target.value }))}
              rows={4} style={{ ...inp, resize: 'vertical' }} />
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={() => setShowSend(null)} style={btnGhost}>Отмена</button>
              <button onClick={sendFirst} disabled={loading} style={btnPrimary}>{loading ? 'Отправляем...' : '✉️ Отправить'}</button>
            </div>
          </div>
        </div>
      )}

      {showPhoneAuth && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 28, width: 420 }}>
            <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 4 }}>Войти по номеру телефона</div>
            <div style={{ fontSize: 13, color: '#888', marginBottom: 20 }}>
              {phoneStep === 1 ? 'Введите номер — придёт код в Telegram' : 'Введите код подтверждения'}
            </div>

            {phoneStep === 1 ? (
              <>
                <input placeholder="+79001234567" value={phoneForm.phone}
                  onChange={e => setPhoneForm(f => ({ ...f, phone: e.target.value }))} style={inp} />

                <div style={{ fontSize: 12, color: '#aaa', marginBottom: 6 }}>
                  api_id и api_hash — получить на my.telegram.org. Если оставить пустыми, используются настройки сервера по умолчанию.
                </div>
                <input placeholder="api_id (необязательно)" value={phoneForm.api_id}
                  onChange={e => setPhoneForm(f => ({ ...f, api_id: e.target.value }))} style={inp} />
                <input placeholder="api_hash (необязательно)" value={phoneForm.api_hash}
                  onChange={e => setPhoneForm(f => ({ ...f, api_hash: e.target.value }))} style={inp} />

                <input placeholder="Название аккаунта (необязательно)" value={phoneForm.name}
                  onChange={e => setPhoneForm(f => ({ ...f, name: e.target.value }))} style={inp} />

                <select value={phoneForm.proxy_id} onChange={e => setPhoneForm(f => ({ ...f, proxy_id: e.target.value }))} style={inp}>
                  <option value="">Без прокси</option>
                  {proxies.map(p => <option key={p.id} value={p.id}>{p.flag && p.flag !== '🌐' ? p.flag + ' ' : ''}{p.url} {p.is_working ? '✓' : ''}</option>)}
                </select>

                <select value={phoneForm.agent_id} onChange={e => setPhoneForm(f => ({ ...f, agent_id: e.target.value }))} style={inp}>
                  <option value="">Агент (можно назначить позже)</option>
                  {agents.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
                </select>
              </>
            ) : (
              <>
                <div style={{ fontSize: 13, marginBottom: 10 }}>Номер: <b>{phoneForm.phone}</b></div>
                <input placeholder="Код из Telegram" value={phoneForm.code}
                  onChange={e => setPhoneForm(f => ({ ...f, code: e.target.value }))} style={inp} />
                <input placeholder="Пароль 2FA (если включён)" type="password" value={phoneForm.password}
                  onChange={e => setPhoneForm(f => ({ ...f, password: e.target.value }))} style={inp} />
              </>
            )}

            {msg && <div style={{ color: '#c0392b', fontSize: 13, marginBottom: 12 }}>{msg}</div>}

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={closePhoneAuth} style={btnGhost}>Отмена</button>
              <button onClick={phoneStep === 1 ? requestPhoneCode : confirmPhoneCode} disabled={loading} style={btnPrimary}>
                {loading ? 'Подождите...' : phoneStep === 1 ? 'Получить код →' : 'Войти'}
              </button>
            </div>
          </div>
        </div>
      )}

      {showBatchUpload && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 28, width: 480, maxHeight: '85vh', overflow: 'auto' }}>
            <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 4 }}>Массовая загрузка аккаунтов</div>
            <div style={{ fontSize: 13, color: '#888', marginBottom: 20 }}>
              ZIP-архив с несколькими аккаунтами: папки с парами .session+.json, или папки tdata/
            </div>

            <div style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 6 }}>ZIP файл</div>
              <input type="file" accept=".zip" multiple onChange={e => setBatchFile(Array.from(e.target.files))}
                style={{ fontSize: 13, width: '100%' }} />
            </div>

            <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 6 }}>Прокси (распределяются по кругу между аккаунтами)</div>
            <div style={{ display: 'grid', gap: 6, marginBottom: 14, maxHeight: 150, overflow: 'auto' }}>
              {proxies.map(p => (
                <label key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, padding: '6px 10px', border: '1px solid #e8e8e6', borderRadius: 8, cursor: 'pointer', background: batchProxyIds.includes(p.id) ? '#f0effe' : '#fff' }}>
                  <input type="checkbox" checked={batchProxyIds.includes(p.id)} onChange={() => toggleBatchProxy(p.id)} />
                  <span style={{ fontFamily: 'monospace' }}>{p.url}</span>
                  {p.is_working ? <span style={{ color: '#27ae60' }}>✓</span> : null}
                </label>
              ))}
              {proxies.length === 0 && <div style={{ color: '#aaa', fontSize: 13 }}>Прокси не добавлены — аккаунты загрузятся без прокси</div>}
            </div>

            <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 6 }}>Агент (для всех загруженных аккаунтов)</div>
            <select value={batchAgentId} onChange={e => setBatchAgentId(e.target.value)} style={inp}>
              <option value="">Назначить позже</option>
              {agents.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
            </select>

            {batchResults && (
              <div style={{ marginTop: 12, marginBottom: 12 }}>
                <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8 }}>
                  {batchResults.ok === false
                    ? <span style={{ color: '#c0392b' }}>{batchResults.error}</span>
                    : <span>Успешно: <span style={{ color: '#27ae60' }}>{batchResults.success}</span> / {batchResults.total}, ошибок: <span style={{ color: '#c0392b' }}>{batchResults.failed}</span></span>}
                </div>
                {batchResults.results && (
                  <div style={{ display: 'grid', gap: 4, maxHeight: 200, overflow: 'auto' }}>
                    {batchResults.results.map((r, i) => (
                      <div key={i} style={{ fontSize: 12, padding: '6px 10px', borderRadius: 6, background: r.ok ? '#eafaf0' : '#fdecea', display: 'flex', gap: 8 }}>
                        <span>{r.ok ? '✓' : '✗'}</span>
                        <span style={{ fontFamily: 'monospace' }}>{r.name}</span>
                        {r.ok ? <span style={{ color: '#27ae60' }}>{r.username || r.phone || r.name}</span> : <span style={{ color: '#c0392b' }}>{r.error}</span>}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 4 }}>
              <button onClick={closeBatchUpload} style={btnGhost}>Закрыть</button>
              <button onClick={uploadBatch} disabled={batchLoading || !batchFile} style={btnPrimary}>
                {batchLoading ? 'Обрабатываем...' : 'Загрузить все'}
              </button>
            </div>
          </div>
        </div>
      )}

      {showSettings && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 28, width: 380 }}>
            <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 16 }}>⚙️ Настройки аккаунта</div>
            <div style={{ fontSize: 13, color: '#888', marginBottom: 16 }}>{showSettings.first_name || showSettings.name}{showSettings.phone ? " · " + showSettings.phone : ""}</div>
            <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 6 }}>Username</div>
            <input placeholder="username (без @)" value={settingsForm.username}
              onChange={e => setSettingsForm(f => ({ ...f, username: e.target.value }))} style={inp} />
            <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 6 }}>Дневной лимит отправки</div>
            <input type="number" min="1" max="500" value={settingsForm.daily_limit}
              onChange={e => setSettingsForm(f => ({ ...f, daily_limit: e.target.value }))} style={inp} />
            <div style={{ fontSize: 12, color: '#aaa', marginBottom: 12 }}>Максимум сообщений в день с этого аккаунта</div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={() => setShowSettings(null)} style={btnGhost}>Отмена</button>
              <button onClick={saveSettings} disabled={loading} style={btnPrimary}>{loading ? '...' : 'Сохранить'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}